import { useCallback, useRef } from 'react';
export default function useOnClickOutside(cb) {
    const ref = useRef(null);
    const handleClick = useCallback((e) => {
        if (ref.current && !ref.current.contains(e.target)) {
            cb?.();
        }
    }, []);
    const onRef = useCallback((node) => {
        if (node) {
            ref.current = node;
            document.addEventListener('click', handleClick);
            return () => {
                document.removeEventListener('click', handleClick);
            };
        }
    }, []);
    return { onRef, ref };
}
